/* eslint-disable indent */

export const paymentTypes = [
  { label: 'Cash', value: 'cash' }
  // { label: 'Card', value: 'card' },
  // { label: 'Paytm', value: 'paytm' },
  // { label: 'Finance', value: 'finance' }
]

export const mathRound = (val, num) => {
  // eslint-disable-next-line no-mixed-operators
  return Math.round(((val ? parseFloat(val) : 0) + Number.EPSILON) * 10 ** num) / 10 ** num
}

export const convertPricePerWeight = (weightType, price) => {
  const stock_price = {}
  const qty = 1

  switch (weightType) {
    case 'milligram':
      stock_price.milligram = mathRound(qty * price, 2)
      stock_price.grams = mathRound(qty * 1000 * price, 2)
      stock_price.ounces = mathRound(qty * 28349.5 * price, 2)
      stock_price['fluid-ounces'] = mathRound(qty * 29573.52 * price, 2)
      stock_price.milliliter = mathRound(qty * 1000 * price, 2)
      stock_price.pounds = mathRound(qty * 453592 * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'grams':
      stock_price.milligram = mathRound((qty * price) / 1000, 3)
      stock_price.grams = mathRound(qty * price, 3)
      stock_price.ounces = mathRound(qty * price * 28.3495, 3)
      stock_price['fluid-ounces'] = mathRound(qty * 29.5735 * price, 3)
      stock_price.milliliter = mathRound(qty * price, 3)
      stock_price.pounds = mathRound(qty * 453.592 * price, 3)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'ounces':
      stock_price.milligram = mathRound((qty * price) / 28349.5, 2)
      stock_price.grams = mathRound((qty * price) / 28.3495, 2)
      stock_price.ounces = mathRound(qty * price, 2)
      stock_price['fluid-ounces'] = mathRound(qty * 0.9586 * price, 2)
      stock_price.milliliter = mathRound((qty * price) / 29.5735, 2)
      stock_price.pounds = mathRound(qty * 16 * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'fluid-ounces':
      stock_price.milligram = mathRound((qty * price) / 29573.52, 2)
      stock_price.grams = mathRound((qty * price) / 29.5735, 2)
      stock_price.ounces = mathRound(qty * price * 1.0431, 2)
      stock_price['fluid-ounces'] = mathRound(qty * price, 2)
      stock_price.milliliter = mathRound((qty * price) / 29.5735, 2)
      stock_price.pounds = mathRound(qty * 15.3378 * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'milliliter':
      stock_price.milligram = mathRound((qty * price) / 1000, 2)
      stock_price.grams = mathRound(qty * price, 2)
      stock_price.ounces = mathRound(qty * 0.03381402 * price, 2)
      stock_price['fluid-ounces'] = mathRound(qty * 0.033814 * price, 2)
      stock_price.milliliter = mathRound(qty * price, 2)
      stock_price.pounds = mathRound(qty * 453.592 * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'pounds':
      stock_price.milligram = mathRound((qty * price) / 453592, 2)
      stock_price.grams = mathRound((qty * price) / 453.592, 2)
      stock_price.ounces = mathRound((qty * price) / 16, 2)
      stock_price['fluid-ounces'] = mathRound((qty * price) / 15.34, 2)
      stock_price.milliliter = mathRound((qty * price) / 453.59, 2)
      stock_price.pounds = mathRound(qty * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    case 'unit':
      stock_price.milligram = mathRound(qty * price, 2)
      stock_price.grams = mathRound(qty * price, 2)
      stock_price.ounces = mathRound(qty * price, 2)
      stock_price['fluid-ounces'] = mathRound(qty * price, 2)
      stock_price.milliliter = mathRound(qty * price, 2)
      stock_price.pounds = mathRound(qty * price, 2)
      stock_price.unit = mathRound(qty * price, 2)
      break
    default:
      break
  }

  return stock_price
}

export const paymentMixins = {
  methods: {
    convertPricePerWeight,
    mathRound
  }
}
